/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/core';
var _ref = {
  name: "8atqhb",
  styles: "width:100%;"
};
export var button = appearance => /*#__PURE__*/css("min-width:188px;", appearance === 'vertical' && _ref);